import React from 'react';
import { Link } from 'wouter';
import { useClientNavigation } from '@/hooks/useClientNavigation';

interface ClientAwareLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const ClientAwareLink: React.FC<ClientAwareLinkProps> = ({ 
  href, 
  children, 
  className,
  onClick 
}) => {
  const { getClientAwarePath } = useClientNavigation();
  
  const clientAwareHref = getClientAwarePath(href);
  
  return (
    <Link href={clientAwareHref} className={className} onClick={onClick}>
      {children}
    </Link>
  );
};